<template><div><h1>VUX V2.5.4 发布日志</h1>
<h2><a href="/zh-CN/components/group.html">Group</a></h2>
<ul><li>[enhance] XSwitch的labelAlign 支持 justify #1707</li>
</ul>
<h2><a href="/zh-CN/components/sticky.html">Sticky</a></h2>
<ul><li>[fix] 在 router-view 动画结束后自动重新绑定</li>
<li>[fix] 修复在ios上fixed不生效的问题 #1657</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] 增加事件 on-index-change #1715</li>
</ul>
<h2><a href="/zh-CN/components/x-img.html">XImg</a></h2>
<ul><li>[feature] 在 router-view 动画结束后自动重新监听加载</li>
</ul>
<h2><a href="/zh-CN/components/bus.html">Bus</a></h2>
<ul><li>[feature] 新插件，用于 vux 组件全局事件管理</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.4-251.vue?72e5865d